/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'help-word': {
    width: 13.473,
    height: 16,
    viewBox: '0 0 13.473 16',
    data: '<path pid="0" d="M8.716 0v3.958a.843.843 0 00.745.837l.1.006h3.913v10.357a.842.842 0 01-.842.842H.842A.842.842 0 010 15.158V.842A.841.841 0 01.842 0h7.874zM2.947 10.105a3.789 3.789 0 103.789-3.79 3.789 3.789 0 00-3.789 3.79zM7.418 8v1.474H9.01v1.263H7.418v1.474H6.056v-1.474H4.462V9.473h1.592V8h1.363zm6.055-3.79h-3.368a.842.842 0 01-.842-.842V0z" _fill="#212121"/>'
  }
})
